import { PaymentReceiptActions } from "@dots-crm/contracts/client";

export const PAYMENT_RECEIPT_ENDPOINTS_URLS = {
  upload: "payment-receipt/upload",
  readMany: "payment-receipt",
  approve: ({ receiptId }: PaymentReceiptActions["approve"]["params"]) =>
    `payment-receipt/${receiptId}/approve`,
  reject: ({ receiptId }: PaymentReceiptActions["reject"]["params"]) =>
    `payment-receipt/${receiptId}/reject`,
};

export const PAYMENT_RECEIPT_TAGS = {
  paymentReceipt: "paymentReceipt",
};
